// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ai-usage-logs {
  padding: 1rem;
}

.ai-usage-logs h2 {
  margin-bottom: 1.5rem;
  color: var(--color-text-primary);
}

/* Stats Summary */
.ai-usage-stats {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.stat-card {
  background: var(--color-card-bg);
  border: 1px solid var(--color-border);
  border-radius: 0.5rem;
  padding: 1rem 1.5rem;
  min-width: 120px;
  text-align: center;
}

.stat-value {
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--color-primary);
}

.stat-label {
  font-size: 0.85rem;
  color: var(--color-text-secondary);
  margin-top: 0.25rem;
}

/* Filters */
.ai-usage-filters {
  margin-bottom: 1rem;
  display: flex;
  gap: 1rem;
  align-items: center;
}

.ai-usage-filters label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: var(--color-text-primary);
}

.ai-usage-filters select {
  padding: 0.5rem;
  border: 1px solid var(--color-border);
  border-radius: 0.25rem;
  background: var(--color-input-bg);
  color: var(--color-text-primary);
}

/* Table */
.ai-usage-table {
  width: 100%;
  font-size: 0.9rem;
  background: var(--color-card-bg);
  border: 1px solid var(--color-border);
  border-radius: 0.5rem;
}

.ai-usage-table th {
  white-space: nowrap;
}

.ai-usage-table .token-cell {
  text-align: right;
  font-family: monospace;
}

.ai-usage-table .no-data {
  text-align: center;
  color: var(--color-text-secondary);
  padding: 2rem;
}

/* Source Badge */
.source-badge {
  display: inline-block;
  padding: 0.2rem 0.5rem;
  border-radius: 0.25rem;
  font-size: 0.8rem;
  font-weight: 500;
}

.source-transcription {
  background: rgba(59, 130, 246, 0.15);
  color: #3b82f6;
}

.source-title_generation {
  background: rgba(16, 185, 129, 0.15);
  color: #10b981;
}

.source-prompt_suggestions {
  background: rgba(139, 92, 246, 0.15);
  color: #8b5cf6;
}

/* Pagination */
.pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid var(--color-border);
}

.pagination-info {
  color: var(--color-text-secondary);
  font-size: 0.9rem;
}

.pagination-controls {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}

.pagination-controls button {
  padding: 0.5rem 1rem;
  background: var(--color-secondary);
  color: var(--color-text-primary);
  border: none;
  border-radius: 0.25rem;
  cursor: pointer;
  font-size: 0.9rem;
}

.pagination-controls button:hover:not(:disabled) {
  background: var(--color-secondary-hover);
}

.pagination-controls button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.page-indicator {
  padding: 0 1rem;
  color: var(--color-text-primary);
}

/* Loading & Error */
.loading {
  text-align: center;
  padding: 2rem;
  color: var(--color-text-secondary);
}

.error-message {
  background: rgba(239, 68, 68, 0.1);
  color: #ef4444;
  padding: 1rem;
  border-radius: 0.5rem;
  margin-bottom: 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/AiUsageLogs.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;EACrC,qBAAqB;EACrB,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,qCAAqC;EACrC,sBAAsB;EACtB,iCAAiC;EACjC,gCAAgC;AAClC;;AAEA,UAAU;AACV;EACE,WAAW;EACX,iBAAiB;EACjB,gCAAgC;EAChC,qCAAqC;EACrC,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,aAAa;AACf;;AAEA,iBAAiB;AACjB;EACE,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,kCAAkC;EAClC,gCAAgC;EAChC,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,aAAa;EACb,qBAAqB;EACrB,mBAAmB;AACrB","sourcesContent":[".ai-usage-logs {\n  padding: 1rem;\n}\n\n.ai-usage-logs h2 {\n  margin-bottom: 1.5rem;\n  color: var(--color-text-primary);\n}\n\n/* Stats Summary */\n.ai-usage-stats {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n  margin-bottom: 1.5rem;\n}\n\n.stat-card {\n  background: var(--color-card-bg);\n  border: 1px solid var(--color-border);\n  border-radius: 0.5rem;\n  padding: 1rem 1.5rem;\n  min-width: 120px;\n  text-align: center;\n}\n\n.stat-value {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: var(--color-primary);\n}\n\n.stat-label {\n  font-size: 0.85rem;\n  color: var(--color-text-secondary);\n  margin-top: 0.25rem;\n}\n\n/* Filters */\n.ai-usage-filters {\n  margin-bottom: 1rem;\n  display: flex;\n  gap: 1rem;\n  align-items: center;\n}\n\n.ai-usage-filters label {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  color: var(--color-text-primary);\n}\n\n.ai-usage-filters select {\n  padding: 0.5rem;\n  border: 1px solid var(--color-border);\n  border-radius: 0.25rem;\n  background: var(--color-input-bg);\n  color: var(--color-text-primary);\n}\n\n/* Table */\n.ai-usage-table {\n  width: 100%;\n  font-size: 0.9rem;\n  background: var(--color-card-bg);\n  border: 1px solid var(--color-border);\n  border-radius: 0.5rem;\n}\n\n.ai-usage-table th {\n  white-space: nowrap;\n}\n\n.ai-usage-table .token-cell {\n  text-align: right;\n  font-family: monospace;\n}\n\n.ai-usage-table .no-data {\n  text-align: center;\n  color: var(--color-text-secondary);\n  padding: 2rem;\n}\n\n/* Source Badge */\n.source-badge {\n  display: inline-block;\n  padding: 0.2rem 0.5rem;\n  border-radius: 0.25rem;\n  font-size: 0.8rem;\n  font-weight: 500;\n}\n\n.source-transcription {\n  background: rgba(59, 130, 246, 0.15);\n  color: #3b82f6;\n}\n\n.source-title_generation {\n  background: rgba(16, 185, 129, 0.15);\n  color: #10b981;\n}\n\n.source-prompt_suggestions {\n  background: rgba(139, 92, 246, 0.15);\n  color: #8b5cf6;\n}\n\n/* Pagination */\n.pagination {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 1rem;\n  padding-top: 1rem;\n  border-top: 1px solid var(--color-border);\n}\n\n.pagination-info {\n  color: var(--color-text-secondary);\n  font-size: 0.9rem;\n}\n\n.pagination-controls {\n  display: flex;\n  gap: 0.5rem;\n  align-items: center;\n}\n\n.pagination-controls button {\n  padding: 0.5rem 1rem;\n  background: var(--color-secondary);\n  color: var(--color-text-primary);\n  border: none;\n  border-radius: 0.25rem;\n  cursor: pointer;\n  font-size: 0.9rem;\n}\n\n.pagination-controls button:hover:not(:disabled) {\n  background: var(--color-secondary-hover);\n}\n\n.pagination-controls button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.page-indicator {\n  padding: 0 1rem;\n  color: var(--color-text-primary);\n}\n\n/* Loading & Error */\n.loading {\n  text-align: center;\n  padding: 2rem;\n  color: var(--color-text-secondary);\n}\n\n.error-message {\n  background: rgba(239, 68, 68, 0.1);\n  color: #ef4444;\n  padding: 1rem;\n  border-radius: 0.5rem;\n  margin-bottom: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
